import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '$store/rootReducer';
import {
  CompleteTaskAction,
  DashboardState,
  LoadDashboardSuccessAction,
  SetCompleteTaskAction,
} from './interface';

const initialState: DashboardState = {
  loadingStatus: 'loading',
  sections: [],
  top: 0,
  notify: null,
  squadId: 0,
};

export const { actions, reducer } = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    loadDashboard(state) {
      state.loadingStatus = 'loading';
    },
    setSquadId(state, action: PayloadAction<number>) {
      state.squadId = action.payload;
    },
    loadDashboardFailure(state) {
      console.log('failed?');
      state.loadingStatus = 'failed';
    },
    setCompleteTask(state, action: SetCompleteTaskAction) {
      for (const section of state.sections) {
        for (const group of section.groups) {
          for (const tasks of group.tasks) {
            if (tasks.id === action.payload.taskId) {
              tasks.isCompleted = action.payload.value;
            }
          }
        }
      }
    },
    completeTask(_, action: CompleteTaskAction) {},
    loadDashboardSuccess(state, action: LoadDashboardSuccessAction) {
      const { sections, percentInTop, notify } = action.payload;

      state.loadingStatus = 'loaded';
      state.sections = sections;
      state.top = percentInTop;
      state.notify = notify;
    },
  },
});

export { reducer as dashboardReducer, actions as dashboardActions };

export const dashboardSelector = (state: RootState) => state.dashboard;
